import {
  ICurrencyFieldConfigurationClient,
  ICurrencyFieldConfigurationServer,
} from "./interface";

export const transformCurrencyFieldConfigClientToServer = (
  fieldConfigClient: ICurrencyFieldConfigurationClient
): ICurrencyFieldConfigurationServer => {
  const {
    separator,
    decimal,
    baseCurrency,
    displayFormat,
    initialValue,
    isNegative,
    placeholder,
    writeJavascript,
    isRoundedNumber,
  } = fieldConfigClient;
  const fieldConfigServer = {
    separator: { selected: separator },
    decimal: { selected: decimal + "" },
    baseCurrency: { selected: baseCurrency },
    displayFormat: { selected: displayFormat },
    initialValue: initialValue,
    isNegativeAllowed: isNegative,
    isRoundedNumber: isRoundedNumber,
    placeHolder: placeholder,
    writeJavascript: writeJavascript,
  };
  return fieldConfigServer;
};

export const transformCurrencyConfigServerToClient = (
  fieldConfigServer: ICurrencyFieldConfigurationServer
): ICurrencyFieldConfigurationClient => {
  const {
    separator,
    decimal,
    baseCurrency,
    displayFormat,
    isNegativeAllowed,
    initialValue,
    placeHolder,
    writeJavascript,
    isRoundedNumber,
  } = fieldConfigServer;
  const fieldConfigClient = {
    separator: separator?.selected,
    decimal: parseInt(decimal?.selected),
    baseCurrency: baseCurrency?.selected,
    displayFormat: displayFormat?.selected,
    isNegative: isNegativeAllowed,
    isRoundedNumber: isRoundedNumber,
    initialValue: initialValue,
    placeholder: placeHolder,
    writeJavascript: writeJavascript,
  };
  return fieldConfigClient;
};
